import controllerBinder from './js/controllers/controller-binder';

import imgSrcController from './js/controllers/image-src-controller';
import clickCountController from './js/tracking/click-count';
import fallbackClickController from './js/tracking/fallback-count';

const controllers = {
    imgSrcController,
    clickCountController,
    fallbackClickController,
};

document.addEventListener('DOMContentLoaded', main);

function main() {
    controllerBinder(document, controllers);
}

export function bindControllers(element: HTMLElement) {
    controllerBinder(element, controllers);
}
